import { openBlock, createElementBlock, createElementVNode } from "vue";
import { _ as _export_sfc } from "./index-nOmQweDK.mjs";
const _sfc_main = {};
const _hoisted_1 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M21.75 10.1236V11.9995C21.75 15.1544 20.2378 18.0117 17.841 19.8064L14.6113 17.4142L14.5981 17.4074C16.0169 16.7263 17.1076 15.5127 17.6402 14.0474L17.7002 13.8734H12.0005V10.1236H21.75Z",
  fill: "#4285F4"
}, null, -1);
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.09255 13.1734C6.12001 13.2703 6.14949 13.3663 6.18094 13.4613C6.25109 13.7422 6.34294 14.021 6.45653 14.2953C7.55247 16.9392 10.3633 18.4411 13.1702 17.8831C14.0519 17.7077 14.8561 17.3444 15.5445 16.8399L18.4909 19.2743C17.2272 20.4027 15.6593 21.2116 13.9021 21.5609C9.34037 22.4679 4.77262 20.027 2.99272 15.7303L2.97266 15.6783L6.09255 13.1734Z",
  fill: "#34A853"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.50703 7.21111L6.64642 9.29014C5.87844 10.8097 5.76845 12.6325 6.45683 14.2953C6.52153 14.4514 6.5922 14.6035 6.66849 14.7514L3.51541 16.8022C3.32164 16.4594 3.14691 16.1018 2.99302 15.7303C1.81507 12.886 2.07539 9.75352 3.50703 7.21111Z",
  fill: "#FBBC05"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M18.7161 4.93285L18.8941 5.10584L16.2422 7.7567C14.2183 5.73281 11.0465 5.42083 8.66664 7.01074C7.5371 7.76535 6.7353 8.84883 6.32166 10.0618L3.24463 7.71018C3.98096 6.20528 5.11097 4.87705 6.58375 3.89291C10.3815 1.35505 15.4213 1.80002 18.7161 4.93285Z",
  fill: "#EA4335"
}, null, -1);
const _hoisted_5 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
  }, _hoisted_5);
}
const icV2LogoGoogleColor = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  icV2LogoGoogleColor as default
};
